// MSAL configuration for Microsoft Entra External ID
import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: import.meta.env.REACT_APP_ENTRA_CLIENT_ID || 'f1bc35de-584b-4c01-8f4c-57736248c764',
        authority: import.meta.env.REACT_APP_ENTRA_AUTHORITY || 'https://billsautomation.ciamlogin.com/d290d079-31b1-49c7-bac1-314599c082b3',
        knownAuthorities: ['billsautomation.ciamlogin.com'],
        redirectUri: window.location.origin || 'http://localhost:3000',
        postLogoutRedirectUri: window.location.origin || 'http://localhost:3000'
    },
    cache: {
        cacheLocation: 'localStorage', // Persist tokens across browser sessions
        storeAuthStateInCookie: false // Set to "true" if you're having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                // Suppress all MSAL logs in production
                if (containsPii) {
                    return;
                }
                // Only log errors in development
                if (import.meta.env.DEV && level === LogLevel.Error) {
                    console.error(message);
                }
            }
        }
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints
export const loginRequest = {
    scopes: ['openid', 'profile', 'email']
};

// Add the endpoints here for Microsoft Graph API services you'd like to use
export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};